import {createReducer, on} from "@ngrx/store";
import {ISharedSolutionStoreState} from "./shared-solution.state";
import {SharedSolutionActions} from "@shared/components/solution/store/shared-solution.actions-type";

export const initialSolutionState: ISharedSolutionStoreState = <ISharedSolutionStoreState>{
  isLoading: false,
  currentSolutionId: undefined,
  currentSolutionList: {
    paging: {
      pageNumber: 1,
      pageSize: 50,
      totalPages: 0,
      totalItems: 0
    },
    filters: [],
    items: [],
  }
};

export const sharedSolutionStore = createReducer(
  initialSolutionState,
  on(SharedSolutionActions.loadSolution, (state, { missionId, filters, noteTopic }) => ({
    ...state,
    currentMissionId: missionId,
    currentNoteTopic: noteTopic,
    currentSolutionList: {
      ...state.currentSolutionList,
      filters: filters ?? []
    },
    isLoading: true,
  })),
  on(SharedSolutionActions.loadSolutionSuccess, (state, { list, noteTopic }) => ({
    ...state,
    currentSolutionList: { ...list },
    currentNoteTopic: noteTopic,
    isLoading: false,
  })),
);


